import Api from './scorm/Api';
import Api1_2 from './scorm/Api1_2';
import Api2004 from './scorm/Api2004';
import ApiDebug from './scorm/ApiDebug';

/**
 * A connector that sends tracker data to the SCORM API. 
 */
class Scorm {

	public api: Api;

	constructor(api: Api) {
		this.api = api;
		this.start();
	}


	start() {

		this.api.start();

		// set the elapsed time and close session, when user closes window
		window.addEventListener('beforeunload', (e: Event) => {
			this.api.finish();
		});
	}



	/* trackSuspendData(renderer: SlideRenderer, root: any) {
		// register suspend data tracker
		var tracker: SuspendData = new SuspendData(this, root);
		renderer.userInput.add(tracker.update.bind(tracker));

		return tracker;
	} */


	/* trackLocation(renderer: SlideRenderer) {

		// register tracker
		var tracker: Location = new Location(this);
		renderer.slideChanged.add(tracker.update.bind(tracker));

		return tracker;
	} */


	/* trackVisibleProgress( renderer: SlideRenderer, threshold:number = 0.8 ) {
		// register tracker
		var tracker: VisibleProgress = new VisibleProgress(this, threshold );
		renderer.slideChanged.add(tracker.update.bind(tracker));

		return tracker;
	} */


	/* trackAnsweredProgress( renderer: SlideRenderer, threshold:number = 0.8 ) {
		// register tracker
		var tracker: AnsweredProgress = new AnsweredProgress( this, threshold );
		renderer.userAnswered.add(tracker.update.bind(tracker));

		return tracker;
	} */

	static find() {

		// search for apis
		var api = Api1_2.find();
		if (!api) api = Api2004.find();

		// fallback to debugger
		if (!api) api = new ApiDebug();

		var scorm = new Scorm(api);
		return scorm;
	}
}

export default Scorm;